import type { Theme } from '@goodtime/engine';
import { buildSlotAssets } from './slotAssets';

const ASSETS = buildSlotAssets('synthwave', {
  cherry: 'cassette',
  lemon: 'neon_shades',
  orange: 'boombox',
  bell: 'synth_bell',
  star: 'sunset_grid_wild',
  seven: 'neon_palm',
  gem: 'synth_gem',
  scatter: 'vinyl_scatter',
  money: 'neon_jackpot',
});

/** Synthwave — GENERATED by scaffoldSlot from
 *  content/slots/synthwave.slot.json.
 *  Edit the spec and regenerate rather than hand-editing this file
 *  (hand edits are overwritten on the next scaffold run). */
export const SYNTHWAVE_THEME: Theme = {
  id: 'synthwave',
  name: 'Synthwave',
  palette: {
    accent: 0xb040d0,
    secondary: 0xe06ab0,
    warm: 0xf2d27a,
    frameFill: 0x1a0e26,
    bgGradientTop: 0x35184a,
    bgGradientBottom: 0x0f0616,
    dimOverlay: 0x07030c,
  },
  slot: {
    symbols: [
      { id: 'cherry', label: 'Cassette', glyph: '📼', tint: 0xc04090, weight: 5, textureAlias: 'synthwave:cherry',
        winVideoAlias: 'synthwave:cherry:win:video', winVideoSpeed: 2 },
      { id: 'lemon', label: 'Shades', glyph: '🕶️', tint: 0xe0457b, weight: 5, textureAlias: 'synthwave:lemon',
        winVideoAlias: 'synthwave:lemon:win:video', winVideoSpeed: 2 },
      { id: 'orange', label: 'Boombox', glyph: '📻', tint: 0xc0a040, weight: 4, textureAlias: 'synthwave:orange',
        winVideoAlias: 'synthwave:orange:win:video', winVideoSpeed: 2 },
      { id: 'bell', label: 'Synth Bell', glyph: '🔔', tint: 0xc0c0d0, weight: 3, textureAlias: 'synthwave:bell',
        winVideoAlias: 'synthwave:bell:win:video', winVideoSpeed: 2 },
      { id: 'star', label: 'Synthwave', glyph: '🌅', tint: 0xe0457b, weight: 2, textureAlias: 'synthwave:star',
        winVideoAlias: 'synthwave:star:win:video', winVideoSpeed: 2 },
      { id: 'seven', label: 'Neon Palm', glyph: '🌴', tint: 0xe04080, weight: 2, textureAlias: 'synthwave:seven',
        winVideoAlias: 'synthwave:seven:win:video', winVideoSpeed: 2 },
      { id: 'gem', label: 'Neon Gem', glyph: '💎', tint: 0xd040c0, weight: 2.5, textureAlias: 'synthwave:gem',
        winVideoAlias: 'synthwave:gem:win:video', winVideoSpeed: 2 },
      { id: 'scatter', label: 'Vinyl', glyph: '💿', tint: 0xc04090, weight: 0.5, textureAlias: 'synthwave:scatter',
        winVideoAlias: 'synthwave:scatter:win:video', winVideoSpeed: 2 },
      { id: 'money', label: 'Neon Treasure', glyph: '💰', tint: 0xf0c860, weight: 1, textureAlias: 'synthwave:money',
        winVideoAlias: 'synthwave:money:win:video', winVideoSpeed: 2, isMoney: true },
      // Gem-on-reel — producer brief 2026-06-04. Scatter-style bonus
      // shared across every biome (registered via SHARED_REEL_SYMBOLS
      // in themes/index.ts). Weights deliberately rare so a gem
      // landing feels like a treat rather than background noise.
      { id: 'gem_t5',  label: 'Gems',     glyph: '💎', tint: 0x3ea7e8, weight: 0.10, gemValue: 5,  textureAlias: 'shared:reel:gem_5' },
      { id: 'gem_t10', label: 'Gem Pile', glyph: '💎', tint: 0x3ea7e8, weight: 0.05, gemValue: 10, textureAlias: 'shared:reel:gem_10' },
    ],
    wildSymbolId: 'star',
    scatterSymbolId: 'scatter',
  },
  wheel: {
    segments: [
      { id: 'x1-a', kind: 'multiplier', label: '×1', tint: 0xb040d0, multiplier: 1, weight: 5 },
      { id: 'x2-a', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x1-b', kind: 'multiplier', label: '×1', tint: 0xb040d0, multiplier: 1, weight: 5 },
      { id: 'x3-a', kind: 'multiplier', label: '×3', tint: 0xe06ab0, multiplier: 3, weight: 3 },
      { id: 'x2-b', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 4 },
      { id: 'x1-c', kind: 'multiplier', label: '×1', tint: 0xb040d0, multiplier: 1, weight: 4 },
      { id: 'x5-a', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x2-c', kind: 'multiplier', label: '×2', tint: 0xf2d27a, multiplier: 2, weight: 3 },
      { id: 'x3-b', kind: 'multiplier', label: '×3', tint: 0xe06ab0, multiplier: 3, weight: 3 },
      { id: 'x1-d', kind: 'multiplier', label: '×1', tint: 0xb040d0, multiplier: 1, weight: 4 },
      { id: 'x5-b', kind: 'multiplier', label: '×5', tint: 0xf2d27a, multiplier: 5, weight: 2 },
      { id: 'x10-a', kind: 'multiplier', label: '×10', tint: 0xf2d27a, multiplier: 10, weight: 1 },
    ],
  },
  assets: {
    slot: ASSETS.slot,
    slotWin: ASSETS.slotWin,
    scene: {
      background: { alias: 'synthwave:bg', path: 'environment/synthwave.png' },
      columnBackground: { alias: 'synthwave:column_bg', path: 'reel/synthwave_column_bg.png' },
      border: { alias: 'synthwave:border', path: 'brand/border_neon.png' },
    },
  },
};
